/**
 * Nox: Aufklapper für die Kategorie-Pillen im Kopf der Kategorieseite.
 *
 * Mobil kommen unter manchen Kollektionen über zwanzig Pillen zusammen. Über
 * zwölf Zeilen gerechnet drückt das die Produkte komplett unter die Falz. Also
 * stehen nur die ersten paar offen, der Rest hängt hinter einem Schalter.
 *
 * Das Skript ist Zugabe, keine Voraussetzung. Eingeklappt wird ausschließlich
 * über das Attribut `data-nox-chips`, und das setzt erst dieses Skript. Lädt es
 * nicht, bleiben alle Pillen sichtbar und der Schalter steht auf `hidden` —
 * also genau der Zustand von vorher, nur ohne toten Knopf.
 *
 * Ob überhaupt eingeklappt wird und ab welcher Breite, entscheidet das CSS über
 * `data-nox-chips-scope` ("mobil" oder "alle"). Hier wird nichts gemessen und
 * kein Resize beobachtet — der Haltepunkt gehört ins Stylesheet, nicht ins JS.
 */

const TOGGLE = '[data-nox-chips-toggle]';

class NoxCollectionChips extends HTMLElement {
  connectedCallback() {
    const schalter = this.querySelector(TOGGLE);

    // Ohne Schalter gibt es nichts zu verbergen: Die Section rendert ihn nur,
    // wenn es mehr Pillen gibt als eingestellt.
    if (!schalter) return;

    this.dataset.noxChips = 'zu';
    schalter.hidden = false;
    schalter.addEventListener('click', () => this.#umschalten(schalter));
  }

  #umschalten(schalter) {
    const istOffen = this.dataset.noxChips === 'offen';

    this.dataset.noxChips = istOffen ? 'zu' : 'offen';
    schalter.setAttribute('aria-expanded', String(!istOffen));
    schalter.textContent = istOffen
      ? schalter.dataset.noxLabelMore
      : schalter.dataset.noxLabelLess;
  }
}

if (!customElements.get('nox-collection-chips')) {
  customElements.define('nox-collection-chips', NoxCollectionChips);
}
